import { useEffect, useState } from "react";

export function useEnvironment(): "browser" | "server" {
  const [env, setEnv] = useState(checkEnv());

  function checkEnv(): "browser" | "server" {
    return typeof window === "undefined" ? "server" : "browser";
  }

  useEffect(() => {
    setEnv(checkEnv());
  }, []);

  return env;
}
